// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-footer[data-v-36bf28b9] {\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
